import React, { Component } from "react";
import Skeleton from "@material-ui/lab/Skeleton";
import ListItem from "@material-ui/core/ListItem";
import { connect } from "react-redux";

class LoadingCell extends Component {
  render() {
    const { language, settings } = this.props;
    const { jumbo_direction } = settings;
    return (
      <div>
        <ListItem
          className="ml-0"
          button
          style={{
            flexDirection:
              language == "english"
                ? jumbo_direction === "ltr"
                  ? "row"
                  : "row-reverse"
                : jumbo_direction === "ltr"
                ? "row-reverse"
                : "row",
            alignItems: "start",
          }}
        >
          <Skeleton
            variant="rect"
            height={150}
            style={{
              borderRadius: 8,
              minWidth: 150,
              maxWidth: 150,
              backgroundColor: "#c3c3c3",
            }}
          />
          <div
            className={"w-100 ".concat(
              jumbo_direction === "rtl"
                ? language === "english"
                  ? "mr-3"
                  : "ml-3"
                : "mx-3"
            )}
          >
            <Skeleton
              style={{
                marginBottom: 10,
                float: language === "arabic" ? "right" : "left",
                width: `${Math.floor(Math.random() * (100 - 25) + 25)}%`,
                backgroundColor: "#c3c3c3",
              }}
            />
            <br />
            <Skeleton style={{ backgroundColor: "#c3c3c3" }} />
            <Skeleton
              style={{
                marginBottom: 10,
                float: language === "arabic" ? "right" : "left",
                width: `${Math.floor(Math.random() * (100 - 30) + 30)}%`,
                backgroundColor: "#c3c3c3",
              }}
            />
            <br />
          </div>
        </ListItem>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    language: state.store.language,
    settings: state.store.store.settings,
  };
};

export default connect(mapStateToProps)(LoadingCell);
